<template>
  <span class="animated-number">
    <transition :name="transitionName" mode="out-in">
      <span class="animated-number__value" :key="value"
        >{{ value }}<span v-html="symbol"></span
      ></span>
    </transition>
  </span>
</template>

<script src="./animated-number.js"></script>
<style src="./animated-number.scss" lang="scss"></style>
